import React from "react";
import AnalyticsHelpIcon from "./AnalyticsHelpIcon";

const DetailSection = ({ title, icon, helpKey, children, className = "" }) => (
  <section className={`analytics-detail-section ${className}`.trim()}>
    {title ? (
      <h4 className="analytics-detail-section__title">
        {icon ? <i className={icon} aria-hidden="true" /> : null}
        {title}
        {helpKey ? <AnalyticsHelpIcon helpKey={helpKey} /> : null}
      </h4>
    ) : null}
    <div className="analytics-detail-section__body">{children}</div>
  </section>
);

export default DetailSection;
